import { ChevronRight } from 'lucide-react'
import { useState } from 'react'

export function Features() {
  const [activeSlide, setActiveSlide] = useState(0)

  const features = [
    {
      title: 'Device-to-Cloud Communication',
      description: 'Data loggers send measurements to remote servers via internet or cellular. Our servers issue remote commands, sending new settings and modes issues from anywhere, reducing the need for on-site visits. Simply send commands and the logger automatically runs instructions when severe weather issues occur.',
      points: [
        'Remote configuration and updates',
        'Real-time data synchronization',
        'Secure and encrypted communication'
      ]
    },
    {
      title: 'Advanced Analytics',
      description: 'Analyze your data with powerful tools and algorithms to identify patterns and trends.',
    },
    {
      title: 'Real-time Monitoring',
      description: 'Get instant notifications and alerts for critical water quality parameters.',
    }
  ]

  return (
    <section id="features" className="py-24">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[140px]">
        <h2 className="text-3xl font-bold text-[#4D4D4D] mb-10">Features</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center features-section rounded-lg">
          {/* System Diagram Image */}
          <div className="flex justify-center order-2 md:order-1">
            <img 
              src="/images/features.png" 
              alt="System Architecture" 
              className="w-full h-auto"
            />
          </div>

          {/* Feature Details */}
          <div className="order-1 md:order-2">
            <h3 className="text-3xl font-bold text-[#4D4D4D] mb-6">
              {features[activeSlide].title}
            </h3>
            <p className="text-gray-700 text-base leading-relaxed mb-8">
              {features[activeSlide].description}
            </p>

            {features[activeSlide].points && (
              <ul className="space-y-4 mb-10">
                {features[activeSlide].points.map((point, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="text-blue-600 font-bold text-xl">✓</span>
                    <span className="text-gray-700 text-base">{point}</span>
                  </li>
                ))}
              </ul>
            )}

            {/* Slide Navigation */}
            <div className="flex justify-between items-center pt-4 border-t border-gray-200">
              <div className="flex gap-3">
                {features.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveSlide(idx)}
                    className={`transition w-3 h-3 rounded-full ${
                      activeSlide === idx ? 'bg-blue-600' : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                    title={features[idx].title}
                  />
                ))}
              </div>
              <button className="text-blue-600 hover:text-blue-700 transition">
                <ChevronRight className="w-8 h-8" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
